export const REFUND_STATUS_PENDING = 'PENDING'
export const REFUND_STATUS_CANCELLED = 'CANCELLED'
export const REFUND_STATUS_PROCESSED = 'PROCESSED'